import { render, staticRenderFns } from "./MatchdaySliderCountdown.vue?vue&type=template&id=042e8718"
import script from "./MatchdaySliderCountdown.vue?vue&type=script&lang=js"
export * from "./MatchdaySliderCountdown.vue?vue&type=script&lang=js"
import style0 from "./MatchdaySliderCountdown.vue?vue&type=style&index=0&id=042e8718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports